const ENV_IDS = {
    prod: {
        en: "G-RHLB2T9RTF",
        bg: "G-8Q41LXF0NM",
    }
};

export const analyticsIds = ENV_IDS[process.env.REACT_APP_ENV] && ENV_IDS[process.env.REACT_APP_ENV][process.env.REACT_APP_LANGUAGE];
